/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {NgModule} from '@angular/core';
import {PasswordValidatorModule} from './password/password-validator.module';
import {MyRequiredValidatorModule} from './required/required-validator.module';
import {EmailValidatorModule} from './email/email-validator.module';
import {MyRequiredFileValidatorModule} from './requiredFile/required-file-validator.module';
import {IsAfterValidatorModule} from './date/is-after-validator.module';

@NgModule({
    imports: [PasswordValidatorModule, MyRequiredValidatorModule, MyRequiredFileValidatorModule, EmailValidatorModule, IsAfterValidatorModule],
    exports: [PasswordValidatorModule, MyRequiredValidatorModule, MyRequiredFileValidatorModule, EmailValidatorModule, IsAfterValidatorModule]
})
export class FormValidationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/form-validation.module.ts